/**
 * @file     quickViewUrl.ts
 * @purpose  The `?listing=<listingKey>` query param that makes a search-page
 *           quick view shareable and Back-closable: read it, add it, strip it,
 *           always keeping every other param.
 */

export const QUICK_VIEW_PARAM = 'listing';

function split(href: string): { path: string; params: URLSearchParams; hash: string } {
  const hashAt = href.indexOf('#');
  const hash = hashAt === -1 ? '' : href.slice(hashAt);
  const rest = hashAt === -1 ? href : href.slice(0, hashAt);
  const queryAt = rest.indexOf('?');
  return {
    path: queryAt === -1 ? rest : rest.slice(0, queryAt),
    params: new URLSearchParams(queryAt === -1 ? '' : rest.slice(queryAt + 1)),
    hash,
  };
}

function join(path: string, params: URLSearchParams, hash: string): string {
  const query = params.toString();
  return `${path}${query ? `?${query}` : ''}${hash}`;
}

export function readQuickViewKey(search: string): string | null {
  return new URLSearchParams(search).get(QUICK_VIEW_PARAM) || null;
}

export function withQuickViewKey(href: string, listingKey: string): string {
  const { path, params, hash } = split(href);
  params.set(QUICK_VIEW_PARAM, listingKey);
  return join(path, params, hash);
}

export function withoutQuickViewKey(href: string): string {
  const { path, params, hash } = split(href);
  params.delete(QUICK_VIEW_PARAM);
  return join(path, params, hash);
}
